import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';

import { MappingStructure } from '@classes/mapping/mapping-structure';
import { MappingTree } from '@classes/mapping/mapping-tree';

@Component({
    selector: 'app-tree-selection',
    templateUrl: './tree-selection.component.html',
    styleUrls: ['./tree-selection.component.scss']
})
export class TreeSelectionComponent implements OnChanges, OnInit {
    @Input() label: string;
    @Input() structure: MappingStructure[] = [];
    @Input() depsLabel: string = "Objets";
    @Input() selection: any[];
    @Output() itemSelected = new EventEmitter<any>();
    @Output() categorySelected = new EventEmitter<any>();
    @Output() refreshSelection = new EventEmitter<void>();

    tree: MappingTree[] = [];

    filterControl = new FormControl<string>("");

    constructor() { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.structure?.currentValue !== changes.structure?.previousValue)
            this.tree = this.initTreeNodes();
    }

    ngOnInit(): void {
        this.initFilter();
    }

    onItemSelected(item: any): void {
        this.itemSelected.emit(item);
    }

    onCategorySelected(category: any): void {
        // console.log(category);
        if (category.dependencies?.length)
            this.categorySelected.emit(category.dependencies);
    }

    onRefreshSelection(): void {
        this.refreshSelection.emit();
    }

    private initTreeNodes(tree?: MappingStructure[]): MappingTree[] {
        let isRoot = false;

        if (!tree) {
            const rootTree = new MappingTree("root", '', 0)
            rootTree.children = this.structure;
            isRoot = true;
            tree = [rootTree];
        }

        return tree.map(item =>
            Object.assign(new MappingTree(), {
                ...item,
                isOpen: isRoot,
                children: item.children ? this.initTreeNodes(item.children as MappingStructure[]) : []
            })
        );
    }

    private initFilter(): void {
        this.filterControl.valueChanges
            .subscribe((value: string) => {
                if (this.structure?.length)
                    this.filterTree(this.tree, value.trim().toLowerCase());
            });
    }

    private filterTree(items: MappingTree[], filterValue: string): boolean {
        if (items && items.length === 0) {
            return false;
        }

        items.map(item => {
            const hasVisibleChildren = this.filterTree(item.children as MappingTree[], filterValue);
            item.isVisible = hasVisibleChildren
                || filterValue === ''
                || filterValue == null
                || item.label.toLowerCase().includes(filterValue)
                || item.dependencies.some(c => c.code.toLowerCase().includes(filterValue));
            if (item.label === 'root') {
                item.isOpen = true;
            } else {
                item.isOpen = filterValue ? hasVisibleChildren : false;
            }
            item.isEditMode = false;
        });

        return items.some(i => i.isVisible);
    }

}
